/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { StyledCountText } from './countTextStyles';
export var CountText = function CountText(props) {
  var intl = useIntl();
  var selectedCount = props.selectedCount,
    loading = props.loading,
    loadingText = props.loadingText,
    total = props.total,
    tableCollectionString = props.tableCollectionString;
  var isCountTextBeingUsedAsTitle = !!total && total < 0;
  var getCountText = function getCountText() {
    if (isCountTextBeingUsedAsTitle) {
      return tableCollectionString;
    }
    if (loading) {
      return loadingText !== null && loadingText !== void 0 ? loadingText : intl.formatMessage({
        id: 'embers.table.topControls.loading',
        defaultMessage: 'Finding results...'
      });
    } else if (!total) {
      return '';
    } else if (selectedCount && selectedCount > 0) {
      return intl.formatMessage({
        id: 'embers.table.topControls.hasSelected',
        defaultMessage: '{selectedCount} of {total} selected: '
      }, {
        selectedCount: selectedCount,
        total: total
      });
    } else {
      return intl.formatMessage({
        id: 'embers.table.topControls.noSelected',
        defaultMessage: '{total} {things}'
      }, {
        total: total,
        things: tableCollectionString
      });
    }
  };
  return /*#__PURE__*/React.createElement(StyledCountText, {
    className: classnames({
      'EmbersTableTopControls-CountText': !isCountTextBeingUsedAsTitle,
      'EmbersTableTopControls-CountTextAsTitle': isCountTextBeingUsedAsTitle
    }),
    role: "status",
    "aria-live": "polite"
  }, getCountText());
};